import React, { useEffect, useState } from 'react';
import {
  CANCEL_REASON_CATEGORIES,
  CANCEL_REASON_CATEGORY_MAP,
} from '../constants/cancelReasonCategories';

const CancelPendingSaleModal = ({ isOpen, onClose, saleLabel, onConfirm }) => {
  const [category, setCategory] = useState(CANCEL_REASON_CATEGORIES[0]?.value || '');
  const [detail, setDetail] = useState('');
  const [error, setError] = useState('');
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setCategory(CANCEL_REASON_CATEGORIES[0]?.value || '');
      setDetail('');
      setError('');
      setIsSaving(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleConfirm = async () => {
    const selectedCategory = String(category || '').trim().toLowerCase();
    const trimmedDetail = detail.trim();
    if (!selectedCategory) {
      setError('Debes seleccionar una categoria de anulacion.');
      return;
    }
    const categoryLabel =
      CANCEL_REASON_CATEGORY_MAP[selectedCategory]?.label || selectedCategory;
    const composedReason = trimmedDetail ? `${categoryLabel}: ${trimmedDetail}` : categoryLabel;
    setError('');
    setIsSaving(true);
    try {
      await onConfirm({
        cancelReasonCategory: selectedCategory,
        cancelReasonDetail: trimmedDetail || null,
        cancelReason: composedReason,
      });
      onClose();
    } catch (err) {
      setError(err?.message || 'No se pudo anular la venta pendiente.');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 z-[1000] flex items-center justify-center p-4"
      onClick={(event) => event.stopPropagation()}
    >
      <div
        className="bg-white w-full max-w-md rounded-lg shadow-lg p-5 relative"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-600 hover:text-black bg-white p-1 rounded-full"
          disabled={isSaving}
        >
          ✕
        </button>
        <h2 className="text-lg font-semibold text-gray-900">Anular venta pendiente</h2>
        <p className="text-sm text-gray-600 mt-1">
          Indica el motivo de anulacion para {saleLabel || 'esta venta'}.
        </p>
        <label className="block text-sm font-medium text-gray-700 mt-4 mb-1">
          Categoria
        </label>
        <select
          className="w-full border rounded p-2 text-sm"
          value={category}
          onChange={(e) => setCategory(e.target.value)}
          disabled={isSaving}
        >
          {CANCEL_REASON_CATEGORIES.map((entry) => (
            <option key={entry.value} value={entry.value}>
              {entry.label}
            </option>
          ))}
        </select>
        <label className="block text-sm font-medium text-gray-700 mt-3 mb-1">
          Detalle (opcional)
        </label>
        <textarea
          className="w-full border rounded p-2 text-sm"
          rows={3}
          value={detail}
          onChange={(e) => setDetail(e.target.value)}
          placeholder="Describe el motivo con mas detalle"
          disabled={isSaving}
        />
        {error && <p className="text-sm text-red-600 mt-2">{error}</p>}
        <div className="flex justify-end gap-2 mt-4">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 text-sm rounded border border-gray-300 text-gray-700 hover:bg-gray-100"
            disabled={isSaving}
          >
            Cancelar
          </button>
          <button
            type="button"
            onClick={handleConfirm}
            className="px-4 py-2 text-sm rounded bg-red-600 text-white hover:bg-red-700 disabled:opacity-60"
            disabled={isSaving}
          >
            {isSaving ? 'Anulando...' : 'Anular venta'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancelPendingSaleModal;
